import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-computing',
  templateUrl: './cloud-computing.component.html',
  styleUrls: ['./cloud-computing.component.scss']
})
export class CloudComputingComponent implements OnInit {
  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 
  section: string = 'cloud-computing'; 
  title: string = 'Consulta Nuestros Precios Sin Compromiso, Contáctanos.'; 

  constructor() { }

  ngOnInit(): void {

  }

}
